module.exports = __webpack_public_path__ + "img/buttom-bgcd.d963b8f6.png";